import { Checkbox } from "@volca/ui/components/ui/checkbox";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import type { WorkbookExportSheet } from "./types";

interface WorkbookSheetSelectionProps {
  sheets: WorkbookExportSheet[];
  selectedIds: string[];
  disabled: boolean;
  onChange: (ids: string[]) => void;
}

export const WorkbookSheetSelection = ({
  sheets,
  selectedIds,
  disabled,
  onChange,
}: WorkbookSheetSelectionProps) => {
  const selectedIdSet = new Set(selectedIds);
  return (
    <>
      <div className="flex items-center justify-between">
        <label className="flex items-center gap-2">
          <Checkbox
            checked={sheets.length > 0 && selectedIds.length === sheets.length}
            indeterminate={
              selectedIds.length > 0 && selectedIds.length < sheets.length
            }
            disabled={disabled || sheets.length === 0}
            onCheckedChange={(checked) =>
              onChange(checked ? sheets.map((sheet) => sheet.id) : [])
            }
          />
          Select all
        </label>
        <span className="text-subtle">
          {selectedIds.length} of {sheets.length} selected
        </span>
      </div>
      <div className="max-h-64 overflow-y-auto rounded-md border border-line p-2">
        {sheets.length === 0 && (
          <Empty className={emptyStateVariants({ layout: "inline" })}>
            <EmptyHeader>
              <EmptyDescription>
                No sheets are available. Close this dialog and refresh the Grid.
              </EmptyDescription>
            </EmptyHeader>
          </Empty>
        )}
        {sheets.map((sheet) => (
          <label
            key={sheet.id}
            className="flex min-h-8 items-center gap-2 px-1"
          >
            <Checkbox
              checked={selectedIdSet.has(sheet.id)}
              disabled={disabled}
              onCheckedChange={(checked) =>
                onChange(
                  checked
                    ? [...selectedIds, sheet.id]
                    : selectedIds.filter((id) => id !== sheet.id),
                )
              }
            />
            <span className="min-w-0 wrap-break-word">{sheet.name}</span>
          </label>
        ))}
      </div>
    </>
  );
};
